<template>
  <div class="form-family-composition" v-if="project != null">
    <h1>CREAR / EDITAR COMPOSICIÓN FAMILIAR</h1>

    <table class="table">
      <thead>
        <tr>
          <th scope="col">Nombre completo</th>
          <th scope="col">Edad</th>
          <th scope="col">Parentesco</th>
          <th scope="col">Estado civil</th>
          <th scope="col">Nivel Educativo</th>
          <th scope="col">Ocupación</th>
          <th scope="col">Editar</th>
          <th scope="col">Eliminar</th>
        </tr>
      </thead>
      <tbody v-if="project.family_compositions.length > 0">
        <tr v-for="family_composition in project.family_compositions" :key="family_composition.id">
          <td>{{family_composition.name}}</td>
          <td>{{family_composition.age}}</td>
          <td>{{ maskName('family_relations', family_composition.relation, 'name') }}</td>
          <td>{{ maskName('civil_types', family_composition.civil_state, 'name') }}</td>
          <td>{{ maskName('education_levels', family_composition.education, 'id') }}</td>
          <td>{{family_composition.occupation}}</td>
          <td><b-button variant="primary" @click.prevent="editarFamilyComposition(family_composition)">Editar</b-button></td>
          <td><b-button variant="danger" @click.prevent="deleteFamilyComposition(family_composition.id)">Eliminar</b-button></td>
        </tr>
      </tbody>
    </table>  
    <hr>
    <table class="table" >
      <thead>
      </thead>
      <tbody>
        <tr>
          <td>Nombre completo</td>
          <td>
            <input type="text" class="form-control" id="name" placeholder="Nombre" v-model="familyComposition.name">
          </td>
          <td>Edad</td>
          <td>
            <input type="number" class="form-control" id="age" placeholder="Edad" v-model="familyComposition.age">
          </td>
        </tr>
        <tr>
          <td>Parentesco</td>
          <td>
            <b-form-select v-model="familyComposition.relation" :options="selects.family_relations" class="form-control" value-field="id" text-field="name"></b-form-select>
          </td>
          <td>Estado civil</td>
          <td>
            <b-form-select v-model="familyComposition.civil_state" :options="selects.civil_types" class="form-control" value-field="id" text-field="name"></b-form-select>
          </td>          
        </tr>
        <tr>
          <td>Nivel educativo</td>
          <td>
            <b-form-select v-model="familyComposition.education" :options="selects.education_levels" class="form-control" value-field="id" text-field="name"></b-form-select>
          </td>
          <td>Ocupación</td>
          <td>
            <input type="text" class="form-control" id="civil_state" placeholder="Ocupación" v-model="familyComposition.occupation">
          </td>
        </tr>
        <tr>
          <td>Empresa en la que trabaja</td>
          <td>
            <input type="text" class="form-control" id="company_name" placeholder="Nombre" v-model="familyComposition.company">
          </td>
          <td>Antiguedad</td>
          <td>
            <input type="text" class="form-control" id="time_worked" placeholder="Antiguedad" v-model="familyComposition.time_worked">
          </td>
        </tr>
        <tr>
          <td>Turno de trabajo</td>
          <td>
            <input type="text" class="form-control" id="schedule" placeholder="Turno" v-model="familyComposition.schedule">
          </td>
        </tr>
        <tr>
          <td>
            <input type="checkbox" class="form-check-input" id="remote_work" v-model="project.remote_work">
            <label class="form-check-label" for="exampleCheck1">¿ Teletrabaja ?</label>
          </td>                    
        </tr>
      </tbody>
    </table>
    <b-button variant="primary" @click.prevent="create" v-if="mode == 'create'">Guardar</b-button>
    <b-button variant="primary" @click.prevent="update" v-if="mode == 'update'">Editar</b-button>
    <b-button variant="success" @click.prevent="clear">limpiar</b-button>
		<div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>
    <div class="row">
      <div class="col-sm-3">Concepto de la dinámica familiar</div>
      <div class="col-sm-9">
        <input type="text" class="form-control" id="name" placeholder="" v-model="project.family_concept">
      </div>
    </div>
    <b-button variant="primary" @click.prevent="save">Guardar</b-button>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'
import SelectLocal from './../../own/select-local.vue'


export default {
  name: 'FormFamilyComposition',
  props: ['project_id', 'assignment_id'],
  computed: {
    ...mapGetters(['projectId', 'assignmentId', 'project', 'assignment', 'selects'])
  },  
  data() {
    return {
			message: '',
      typeMessage: '',
      familyComposition: { id: null},
      mode: 'create'
    }
  },
  components: {
    'select-local': SelectLocal,
  },  
  methods: {
    save(){
      this.defaultAxios()
      let project = this.project
      delete project.family_compositions
      delete project.family_references
      delete project.family_sicks
      delete project.working_condition
      delete project.laboral_references
      delete project.family_interviews
			axios.put(`/update_information_personal`, { project: project }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Proceso actualizado', 'alert-success')
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },    
    ...mapMutations(['changeProjectId', 'changeAssignmentId', 'changeProject', 'changeAssignment', 'changeSelects']),
    maskName(attribute, value, itemSearch){
      if (value != null && value != "") {
        return this.selects[attribute].filter(obj => obj[itemSearch] == value)[0].name
      }else{
        return 'N/A'
      }      
    },
    clear(){
      this.familyComposition = { id: null}
      this.mode = 'create'
    },
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    getInformationWork() {
      console.log("->getInformationWork**")
      console.log(`/information_work.json?project_id=${this.project_id}&assignment_id=${this.assignment_id}`)
			axios.get(`/information_work.json?project_id=${this.project_id}&assignment_id=${this.assignment_id}`).then(res=>{
				if(res.status == 200){
          this.changeProject(res.data.project)
          console.log('res.data.project -> ' + res.data.project.family_concept)
          console.log('this.project ' + this.project.family_concept)
          this.changeAssignment(res.data.assignment)
          this.changeSelects(res.data.selects)
				}
			})
    },
    editarFamilyComposition(family_composition){
      this.familyComposition = family_composition
      this.mode = 'update'
    },
    create(){
      this.defaultAxios()
      delete this.familyComposition.id
			axios.post(`/workflow/family_compositions`, { id: this.projectId, family_composition: this.familyComposition }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Guardado', 'alert-success')
          this.clear()
				}else{
          this.showMessage('No se pudo guardar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('No se pudo guardar', 'alert-danger')
      })
    },
    update(){
      this.defaultAxios()
			axios.put(`/workflow/family_compositions/${this.familyComposition.id}`, { family_composition: this.familyComposition }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Registro actualizado', 'alert-success')
          this.clear()
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },    
    deleteFamilyComposition(id){
      this.defaultAxios()
			axios.delete(`/workflow/family_compositions/${id}`, {}).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Faamiliar eliminado', 'alert-success')
				}else{
          this.showMessage('No se pudo eliminar el familiar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('No se pudo eliminar el familiar', 'alert-danger')
      })
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},        
  },
  created () {

  },
  watch: {

  },
  filters: {

  }
}
</script>

<style scoped>

</style>